module.exports = __webpack_public_path__ + "static/media/santa-hat.16155e7d.png";